// Utilitaires WhatsApp — collecte, nettoyage léger et lien d'ouverture manuelle.
//
// IMPORTANT : aucune API WhatsApp / Meta n'est appelée ici. On prépare UNIQUEMENT
// la donnée (stockage du numéro) et l'ouverture manuelle d'une conversation via le
// lien officiel `https://wa.me/<numéro>`. Aucun message n'est envoyé automatiquement.

/**
 * Nettoie légèrement un numéro saisi : retire les espaces et séparateurs usuels,
 * conserve un éventuel « + » initial. Aucune transformation arbitraire d'un
 * numéro étranger (on ne force pas le préfixe burkinabè).
 */
export function nettoyerNumeroWhatsapp(value: string): string {
  if (!value) return "";
  const trimmed = value.trim();
  const hasPlus = trimmed.startsWith("+");
  // On garde uniquement les chiffres + le « + » initial.
  const digits = trimmed.replace(/[^\d]/g, "");
  return hasPlus ? `+${digits}` : digits;
}

/**
 * Construit un lien d'ouverture WhatsApp à partir d'un numéro réel.
 * Renvoie `null` si aucun numéro exploitable n'est présent (jamais de faux lien).
 * Le numéro est réduit à ses chiffres (indicatif inclus) comme exigé par wa.me.
 */
export function buildWhatsappLink(value: string | null | undefined): string | null {
  const digits = (value ?? "").replace(/[^\d]/g, "");
  if (digits.length < 8) return null;
  return `https://wa.me/${digits}`;
}

/** Indique si un numéro WhatsApp exploitable est disponible. */
export function hasWhatsapp(value: string | null | undefined): boolean {
  return buildWhatsappLink(value) !== null;
}